export default __webpack_public_path__ + "static/portfolio-sidebar-fluid-3e8fa99b3e0d260e7232b41ed9550578.jpg";